import DailyBoxDelete from './DailyBoxDelete'
export {DailyBoxDelete}
export default DailyBoxDelete
